export const DATE_TIME_TYPES = {
  DATE: 'DD/MM/YYYY',
  DATE_TIME: 'DD/MM/YYYY HH:mm:ss',
  DATE_TIME_12H: 'DD/MM/YYYY hh:mm A',
  ISO_DATE: 'YYYY-MM-DD',
  ISO_DATE_TIME: 'YYYY-MM-DD HH:mm:ss',
  ISO_DATE_TIME_12H: 'YYYY-MM-DD hh:mm A',
  DATE_DD_MMM_YYYY: 'DD-MMM-YYYY',
  ISO_DATE_TIME_UTC: 'YYYY-MM-DDTHH:mm:ss[Z]',
  ISO_DATE_TIME_OFFSET: 'YYYY-MM-DDTHH:mm:ssZ'
};
